<template>
  <TableList
    class="role-management-list"
    row-key="id"
    v-rect-loading="loading"
    :title="$t(`${i18nPrefix}.title.roleManagement`)"
    :listData="roleList"
    :tableColumns="tableColumns"
    :actionBtn="actionBtn"
    :showCreateBtn="false"
    :hideOnClick="true"
    :pagination="pagination"
    @pagination-change="handlePaginationChange"
  >
    <template #btn>
      <el-button class="blue-btn" @click="handelAddRole">{{ $t(`${i18nPrefix}.btn.addRole`) }}</el-button>
    </template>
    <template #page-bottom>
      <DialogWrapper
        saveBtnLabelI18nKey="common.btn.confirm"
        closeOnCancel
        :title="$t(`${i18nPrefix}.message.deleteConfirm`, { roleName: deleteRoleInfo.roleTitle })"
        :loading="deleteDialog.loading"
        :show.sync="deleteDialog.show"
        @save="handleDelete"
      >
      </DialogWrapper>
    </template>
  </TableList>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import TableList from '@/components/tableList/allowDragSortTable.vue'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
export default {
  components: {
    TableList,
    DialogWrapper
  },
  data () {
    return {
      i18nPrefix: 'admin.company.roleManagement',
      loading: false,
      roleList: [],
      actionBtn: {
        edit: {
          show: true,
          onclick: this.handleEditRole
        },
        delete: {
          show: true,
          onclick: this.handleDeleteRole
        }
      },
      showDeleteDialog: false,
      deleteDialog: {
        show: false,
        loading: false
      },
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      deleteRoleInfo: { }
    }
  },
  computed: {
    tableColumns () {
      const columns = [
        {
          label: this.$t(`${this.i18nPrefix}.label.roleName`),
          dataKey: 'roleTitle',
          showOverflowTooltip: true
        }
      ]
      return columns
    }
  },
  created () {
    this.initData()
  },
  methods: {
    ...mapActions('roleManagement', ['getRoleList', 'deleteRole']),
    async initData () {
      this.loading = true
      try {
        const params = {
          page: this.pagination.page,
          page_size: this.pagination.pageSize
        }
        const resp = await this.getRoleList(params)
        this.roleList = _.map(resp.role_list, (role) => ({
          id: role.id,
          roleTitle: role.title
        }))
        this.pagination.total = resp.total_count
      } finally {
        this.loading = false
      }
    },
    handlePaginationChange () {
      this.initData()
    },
    handelAddRole () {
      this.$router.push('/v-admin/role/management/add')
    },
    handleEditRole (row) {
      this.$router.push(`/v-admin/role/management/edit/${row.id}`)
    },
    async handleDelete () {
      this.deleteDialog.loading = true
      try {
        const resp = await this.deleteRole(this.deleteRoleInfo.id)
        if (resp) {
          this.$message.success(this.$t(`${this.i18nPrefix}.message.optionSuccess`))
        }
        this.deleteDialog.show = false
      } finally {
        this.deleteDialog.loading = false
      }
      await this.initData()
    },
    handleDeleteRole (row) {
      this.deleteRoleInfo = row
      this.deleteDialog.show = true
    }
  }
}
</script>

<style lang="scss" scoped>
.role-management-list {

}
</style>
